function normalizeVoiceName(name) {
  return (name || '').toLowerCase().replace(/[\s_-]/g, '');
}

function isChineseVoice(voice) {
  const lang = (voice.lang || '').toLowerCase();
  return lang.startsWith('zh') || lang.includes('cn') || lang.includes('hans');
}

function detectPlatform() {
  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  if (/Mac|iPhone|iPad|iPod/.test(platform) || /Mac OS/.test(ua)) return 'mac';
  if (/Win/.test(platform) || /Windows/.test(ua)) return 'windows';
  return 'other';
}

export function pickSoftFemaleChineseVoice(voices) {
  if (!voices || voices.length === 0) return null;

  const zhVoices = voices.filter(isChineseVoice);
  const availableVoices = zhVoices.length > 0 ? zhVoices : voices;
  const platform = detectPlatform();

  const macPriority = [
    'tingting',
    '婷婷',
    'meijia',
    '美佳',
    '美嘉',
    'yushu',
    '语舒',
    '語舒',
    'shelley',
    'sandy',
    'samantha',
    'child',
    '儿童',
    '童声',
    '女声',
    '女',
    'kid',
    'girl',
    'female',
    'siri'
  ];
  const windowsPriority = ['xiaoyi', '小艺', 'yaoyao', '瑶瑶', 'xiaoxiao', '晓晓', '曉曉', 'huihui', '慧慧', 'child', '儿童', '童声', 'girl', 'female', '女声'];
  const maleKeywords = ['male', '男', 'limu', '李木', 'yunjian', '云健', '雲健', 'yunxi', '云希', '雲希', 'yunyang', '云扬', '雲揚', 'kangkang', '康康'];
  const priority = platform === 'mac'
    ? macPriority
    : platform === 'windows'
      ? windowsPriority
      : [...macPriority, ...windowsPriority];
  const nonMaleVoices = availableVoices.filter(voice => {
    const name = normalizeVoiceName(`${voice.name} ${voice.voiceURI}`);
    return !maleKeywords.some(keyword => name.includes(normalizeVoiceName(keyword)));
  });
  const candidates = nonMaleVoices.length > 0 ? nonMaleVoices : availableVoices;

  for (const keyword of priority) {
    const normalizedKeyword = normalizeVoiceName(keyword);
    const matched = candidates.find(voice => {
      const name = normalizeVoiceName(`${voice.name} ${voice.voiceURI}`);
      return name.includes(normalizedKeyword);
    });
    if (matched) return matched;
  }

  return candidates.find(voice => voice.lang.startsWith('zh-CN'))
    || candidates.find(voice => voice.lang.startsWith('zh'))
    || candidates[0]
    || voices[0];
}

export function getPoemSpeakSettings() {
  return {
    rate: 0.82,
    pitch: 1.12,
    volume: 0.9
  };
}

export function speakPoemText(text, { onStart, onBoundary, onEnd, onError } = {}) {
  return new Promise((resolve) => {
    const content = (text || '').trim();
    if (!content) {
      resolve(null);
      return;
    }

    const startSpeaking = () => {
      const utterance = new SpeechSynthesisUtterance(content);
      const voice = pickSoftFemaleChineseVoice(window.speechSynthesis.getVoices());
      const settings = getPoemSpeakSettings();

      if (voice) utterance.voice = voice;
      if (voice) {
        console.info('诗词朗读语音:', voice.name, voice.lang);
      }
      utterance.lang = voice?.lang || 'zh-CN';
      utterance.rate = settings.rate;
      utterance.pitch = settings.pitch;
      utterance.volume = settings.volume;
      utterance.onstart = () => onStart?.();
      utterance.onboundary = (event) => onBoundary?.(event);
      utterance.onend = () => onEnd?.();
      utterance.onerror = () => onError?.();

      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(utterance);
      resolve(utterance);
    };

    if (window.speechSynthesis.getVoices().length > 0) {
      startSpeaking();
      return;
    }

    window.speechSynthesis.onvoiceschanged = () => {
      window.speechSynthesis.onvoiceschanged = null;
      startSpeaking();
    };
  });
}
